module.exports = __webpack_public_path__ + "static/media/about-us.38e1edd4.jpeg";